<!-- eslint-disable max-lines -->
<template>
    <div class="base-form">
        <!-- 审核驳回时显示的拒绝原因 -->
        <el-alert v-if="!!editFormAdvInfo.audit_reason" type="error">
            <template slot="title">
                <div class="audit-error-tips">
                    <img :src="iconError" />
                    <p class="title">审核驳回</p>
                    <p class="desc">{{ editFormAdvInfo.audit_reason || '' }}</p>
                </div>
            </template>
        </el-alert>
        <el-form ref="form" :model="form" :rules="rules" label-width="170px" class="form-box">
            <!-- 基本信息 -->
            <div class="form-title" @dblclick="mockForm"><Title text="基本信息"></Title></div>
            <el-form-item label="广告主公司名称" prop="company" style="margin-bottom: 4px">
                <div class="pure-text">{{ form.company }}</div>
            </el-form-item>
            <el-form-item label="品牌" prop="brand" style="margin-bottom: 4px">
                <div class="pure-text">{{ brandText }}</div>
            </el-form-item>
            <el-form-item label="关联产品">
                <el-tag v-for="(pi, pin) in productText" :key="pin" style="margin-right: 8px;" type="success">{{
                    pi
                }}</el-tag>
                <el-tooltip effect="light" placement="top" content="如果新加产品，请去详情页修改">
                    <img class="form-tip-icon" :src="iconTip" style="right: auto; margin-left: 24px;" />
                </el-tooltip>
            </el-form-item>

            <!-- 账号和产品信息 -->
            <div class="form-title"><Title text="账号和产品信息"></Title></div>
            <template v-if="formType === 'init'">
                <el-form-item label="开户产品">
                    <el-tag style="margin-right: 8px;" type="success">{{ initFormProductInfo.product_name }}</el-tag>
                    <el-tooltip effect="light" placement="top" content="开户的产品，不能修改">
                        <img class="form-tip-icon" :src="iconTip" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="开户链接" prop="link">
                    <el-input v-model="form.link" ref="form_link" placeholder="请输入开户链接"></el-input>
                </el-form-item>
                <el-form-item label="代理商" prop="agent_id">
                    <el-select
                        v-model="form.agent_id"
                        clearable
                        filterable
                        remote
                        :remote-method="_fetchAgentList"
                        placeholder="请输入并选择代理商"
                        style="width: 100%"
                        @change="handleSelectAgent"
                    >
                        <el-option
                            v-for="item in agentsOps"
                            :key="item.agent_id"
                            :label="item.agent_name"
                            :value="item.agent_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="!!form.channel_sales_name" label="所属渠道销售" style="margin-bottom: 4px">
                    <div class="pure-text">{{ form.channel_sales_name }}</div>
                </el-form-item>
                <el-form-item label="广告主账户名" prop="account_name">
                    <el-input v-model="form.account_name" placeholder="请输入广告主账户名"></el-input>
                </el-form-item>
                <el-form-item label="广告主密码" prop="password">
                    <el-input v-model="form.password" placeholder="请输入广告密码" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input v-model="form.confirmPassword" placeholder="请确认广告主密码" show-password></el-input>
                </el-form-item>

                <el-form-item label="行业" prop="category">
                    <el-cascader
                        style="width: 100%"
                        expand-trigger="hover"
                        :options="categoryOps"
                        :props="categoryProps"
                        v-model="form.category"
                    >
                    </el-cascader>
                </el-form-item>
            </template>
            <template v-else-if="formType === 'edit'">
                <el-form-item label="开户产品">
                    <el-tag style="margin-right: 8px;" type="success">{{ editFormAdvInfo.product_name }}</el-tag>
                    <el-tooltip effect="light" placement="top" content="已经提交开户的产品，不能修改">
                        <img class="form-tip-icon" :src="iconTip" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="开户链接" prop="link">
                    <el-input v-model="form.link" ref="form_link" placeholder="请输入开户链接"></el-input>
                </el-form-item>
                <el-form-item label="代理商" style="margin-bottom: 4px">
                    <div class="pure-text">{{ editFormAdvInfo.agent_name }}</div>
                </el-form-item>
                <el-form-item label="所属渠道销售" style="margin-bottom: 4px">
                    <div class="pure-text">{{ editFormAdvInfo.channel_name }}</div>
                </el-form-item>
                <el-form-item label="广告主编号" style="margin-bottom: 4px">
                    <div class="pure-text">{{ editFormAdvInfo.customer_id }}</div>
                </el-form-item>
                <el-form-item label="广告主账户名" style="margin-bottom: 4px">
                    <div class="pure-text">{{ editFormAdvInfo.account_name }}</div>
                </el-form-item>
                <el-form-item label="所有行业" style="margin-bottom: 4px">
                    <div class="pure-text">{{ editFormAdvInfo.category_name }}</div>
                </el-form-item>
            </template>

            <!-- 资质信息 -->
            <div class="form-title"><Title text="资质信息"></Title></div>
            <el-form-item label="营业执照代码" prop="license_code">
                <el-input v-model="form.license_code" placeholder="请输入营业执照统一社会信用代码"></el-input>
            </el-form-item>
            <el-form-item label="营业执照" prop="license">
                <upload-img
                    v-on:delete="handleDelete"
                    v-on:upload="handleUpload"
                    sign="license"
                    :imgs="form.license"
                    :limit="1"
                ></upload-img>
            </el-form-item>
            <el-form-item label="资质证明" prop="qualification">
                <template slot="label">
                    <el-popover placement="top" width="160" trigger="hover">
                        <el-button type="primary" size="mini" @click="toViewOpenState()"
                            >点击查看开户资质说明</el-button
                        >
                        <div slot="reference">资质证明<i class="el-icon-question"></i></div>
                    </el-popover>
                </template>
                <upload-img
                    v-on:delete="handleDelete"
                    v-on:upload="handleUpload"
                    sign="qualification"
                    :multiple="true"
                    :imgs="form.qualification"
                ></upload-img>
            </el-form-item>

            <!-- 客户联系人信息 -->
            <div class="form-title"><Title text="客户联系人信息"></Title></div>
            <el-form-item label="联系人姓名" prop="contacter">
                <el-input v-model="form.contacter" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系人邮箱" prop="contacter_email">
                <el-input v-model="form.contacter_email" placeholder="请输入联系人邮箱"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="contacter_phone">
                <el-input v-model="form.contacter_phone" placeholder="请输入联系人电话"></el-input>
            </el-form-item>

            <!-- 其他信息 -->
            <div class="form-title"><Title text="其他信息"></Title></div>
            <el-form-item label="公司所在地" prop="register_address">
                <el-cascader
                    style="width: 100%"
                    placeholder="请选择广告主市场部所在城市"
                    expand-trigger="hover"
                    :options="cityOps"
                    :props="cityOpsProps"
                    v-model="form.register_address"
                >
                </el-cascader>
                <el-tooltip effect="light" placement="top" content="请填写广告主部门市场所在城市">
                    <img class="form-tip-icon" :src="iconTip" />
                </el-tooltip>
            </el-form-item>
            <el-form-item label="广告主来源" prop="origin">
                <el-radio-group v-model="form.origin">
                    <el-radio v-for="item in aderSource" :key="item.id" :label="item.id">{{ item.text }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="运营方" prop="operator">
                <el-radio-group v-model="form.operator">
                    <el-radio v-for="item in operationSource" :key="item.id" :label="item.id">{{ item.text }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="投放广告位" prop="adslot_type" style="margin-bottom: 46px;">
                <el-checkbox-group v-model="form.adslot_type">
                    <el-checkbox v-for="item in adPosition" :key="item.id" :label="item.id">
                        {{ item.text }}
                    </el-checkbox>
                </el-checkbox-group>
                <el-checkbox v-model="form.adslot_type_other">
                    其他
                    <el-input
                        v-show="form.adslot_type_other"
                        v-model="form.adslot_type_ext"
                        ref="adslot_type_ext"
                        placeholder="请输入投放广告位"
                    >
                    </el-input>
                </el-checkbox>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
                <el-input
                    class="comment-input"
                    type="textarea"
                    v-model="form.remarks"
                    placeholder="请填写投放时间，趣头条投放预算（年预算、日消耗）、考核指标和指标值、竞媒投放预算（年预算、日消耗）、考核指标和指标值"
                ></el-input>
                <el-tooltip effect="light" placement="top">
                    <div slot="content">
                        请填写投放时间，趣头条投放预算<br />（年预算、日消耗）、考核指标和指标值<br />竞媒投放预算（年预算、日消耗）、考核指标和指标值
                    </div>
                    <img class="form-tip-icon" :src="iconTip" />
                </el-tooltip>
            </el-form-item>

            <!-- ops -->
            <el-form-item>
                <el-button type="primary" :loading="submitLoading" @click="submitFormAction('form')"
                    >&nbsp;提交审核&nbsp;</el-button
                >
                <el-button @click="backAction">&nbsp;取&nbsp;消&nbsp;</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Mock from 'mockjs';
import { mapGetters, mapState } from 'vuex';
import Request from '@/core/QuRequest';
import Title from '@/components/Title';
import UploadImg from '@/components/UploadImg';
import cityMap from '@/common/cityMap';
// import $conf from '@/common/conf';
import $util from '@/common/js/util';
import { aderSource, operationSource, adPosition } from '../conf';
import IconTip from '@/assets/image/icon/tip-icon.png';
import IconError from '@/assets/image/icon/error-icon.png';

// eslint-disable-next-line no-undef
const codeEvn = CODE_EVN;
const isProduction = codeEvn === 'production' || codeEvn === 'preview';
const req = new Request();

/* *
 * 选择部分数组转字符串
 */
const pickAttrToStr = (obj = {}, arr = []) => {
    return arr.reduce((i, v) => {
        v in obj && (i[v] = obj[v].join(','));
        return i;
    }, {});
};

export default {
    name: 'AdvertiserManagePrivateInitAder',
    components: { Title, UploadImg },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['advUserId']),
        brandText () {
            const brandId = this.form.brand || '';
            const brands = this.brands || [];
            return (brands.find(i => i.id === brandId) || {}).name || '暂无';
        }
    },
    watch: {
        'form.adslot_type_other' (v) {
            // 切换广告位其他，清空'其他输入'；
            this.form.adslot_type_ext = '';
            // 聚焦
            if (v) {
                this.$nextTick(() => {
                    this.$refs.adslot_type_ext.focus();
                });
            }
        }
    },
    props: {
        brands: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data () {
        const formRules = {
            link: [
                { required: true, message: '开户链接必填', triggle: 'blur' },
                {
                    pattern: /^(https|http):\/\//,
                    message: '必须为http://或https://开头，最多255字符',
                    triggle: 'blur'
                }
            ],
            agent_id: [{ required: true, message: '请输入并选择代理商', trigger: 'change' }],
            account_name: [
                { required: true, message: '广告主账户名必填', type: 'string', triggle: 'blur' },
                { min: 1, max: 256, message: `长度为1-256`, triggle: 'blur' },
                {
                    pattern: /^[\u4e00-\u9fffa-zA-Z\d\s|\\(|\\)|\\（|\\）]+$/,
                    message: '只能包含汉字、英文字母、数字、中英文括号、英文单词等',
                    triggle: 'blur'
                }
            ],
            password: [
                { required: true, message: '广告主密码必填', triggle: 'blur' },
                { min: 6, max: 30, message: `长度为6-30`, triggle: 'blur' },
                {
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,30}$/,
                    message: '必须包含大小写字母、数字（只允许数字、字母）',
                    triggle: 'blur'
                },
                {
                    validator: (rule, value, callback) => {
                        if (this.form.confirmPassword !== '') {
                            this.$refs.form.validateField('confirmPassword');
                        }
                        callback();
                    }
                }
            ],
            confirmPassword: [
                { required: true, message: '请再次输入密码', triggle: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        if (value !== this.form.password) {
                            callback(new Error('两次输入密码不一致!'));
                        } else {
                            callback();
                        }
                    },
                    triggle: 'blur'
                }
            ],
            category: [{ type: 'array', required: true, message: '请选择行业', trigger: 'blur' }],
            license_code: [
                { required: true, message: '营业执照统一信息社会代码必填', triggle: 'blur' },
                {
                    pattern: /^[A-Z\d]{18}$/,
                    message: '只能包含数字、大写英文字母, 18位',
                    triggle: 'blur'
                }
            ],
            license: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (this.form.license.length <= 0) {
                            callback(new Error('请上传营业执照'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            qualification: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (this.form.qualification.length <= 0) {
                            callback(new Error('请上传资质证明'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            contacter: [
                { required: true, message: '联系人姓名必填', triggle: 'blur' },
                { min: 1, max: 50, message: `长度为1-50`, triggle: 'blur' }
            ],
            contacter_phone: [
                { required: true, message: '联系人电话必填', triggle: 'blur' },
                {
                    pattern: /^1[3-9][0-9]\d{8}$/,
                    message: '输入正确的手机号',
                    triggle: 'blur'
                }
            ],
            contacter_email: [
                {
                    pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@([a-zA-Z0-9]+[-.])+[a-zA-Z0-9]{2,}$/,
                    message: '输入正确的邮箱',
                    triggle: 'blur'
                }
            ],
            register_address: [{ type: 'array', required: true, message: '请选择公司地址', trigger: 'blur' }],
            origin: [{ type: 'number', required: true, message: '广告主来源必选', triggle: 'change' }],
            operator: [{ type: 'number', required: true, message: '运营方必选', triggle: 'change' }],
            adslot_type: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value.length <= 0 && !this.form.adslot_type_ext) {
                            callback(new Error('请选择投放广告位或选择其他输入'));
                        } else {
                            callback();
                        }
                    },
                    triggle: 'blur'
                }
            ],
            remarks: [{ required: true, min: 20, max: 1024, message: `长度为20-1024`, triggle: 'blur' }]
        };

        return {
            owner: '',
            formType: 'init', // init为开户 edit为修改
            editFormAdvInfo: {},
            iconTip: IconTip,
            iconError: IconError,
            cityOps: cityMap.data,
            aderSource,
            operationSource,
            adPosition,
            products: [],
            categoryOps: [],
            agentsOps: [],
            submitLoading: false,
            tempAgentName: '',
            formRules,
            productText: [],
            // 状态
            auditStatus: {
                id: 0,
                reason: ''
            },
            cityOpsProps: {
                label: 'text',
                value: 'text',
                children: 'children'
            },
            categoryProps: {
                label: 'name',
                children: 'child'
            },
            form: {
                customer_id: '',
                company: '',
                brand: '',
                product_id: '',
                agent_id: '',
                agent_name: '', // 用来匹配校验用的
                channel_sales_id: '',
                channel_sales_name: '',
                link: '',
                account_name: '',
                password: '',
                confirmPassword: '',
                category: [],
                license_code: '',
                license: [],
                qualification: [],
                contacter: '',
                contacter_phone: '',
                contacter_email: '',
                register_address: [],
                origin: '',
                adslot_type: [],
                adslot_type_other: false,
                adslot_type_ext: '',
                operator: '',
                remarks: ''
            },
            rules: {}
        };
    },
    methods: {
        // 获取行业数据
        async _getCategoryConfig () {
            try {
                const res = await req.send(req.Apis.sales.common.category);
                this.categoryOps = res.data;
            } catch (err) {
                this.$message.error(`获取行业数据失败：${err.message || '未知错误'}`);
            }
        },

        // 获取详情
        async _getDetail () {
            try {
                const params = {
                    customer_id: this.form.customer_id,
                    type: '1',
                    owner: this.owner || ''
                };
                const res = await req.send(req.Apis.sales.customerStage2.detail, params);
                const data = res.data || {};
                this.products = (data || {}).product;
                const products = (data || {}).product;
                this.productText = products && products.length > 0 ? products.map(p => p.product_name) : ['--'];
                this.resetFormByDetail(data);
            } catch (err) {
                this.$message.error(`获取详情失败：${err.message || '未知错误'}`);
            }
        },

        // async 提交
        async processSubmit () {
            try {
                const formArrItems = ['license', 'qualification', 'register_address', 'adslot_type', 'category'];
                const params = {
                    ...this.form,
                    ...pickAttrToStr(this.form, formArrItems)
                };
                if (this.formType === 'edit') {
                    params.adv_user_id = this.editFormAdvInfo.adv_user_id || '';
                }

                this.submitLoading = true;
                const _api = this.formType === 'init' ? 'createAccount' : 'updateAccount';
                await req.send(req.Apis.sales.customerStage2[_api], params).fin(() => {
                    this.submitLoading = false;
                });

                this.$router.replace({
                    name: 'AdvertiserManagePrivateInitAderResult',
                    query: {
                        customerId: this.form.customer_id,
                        owner: this.owner
                    }
                });
            } catch (err) {
                this.submitLoading = false;
                this.$message({
                    message: `开户失败：${err.message || '未知错误'}`,
                    type: 'error',
                    duration: 4000
                });
            }
        },

        // reset form
        resetFormByDetail (data = {}) {
            const toArr = val => (val ? (val || '').split(',') : []);
            this.form = {
                ...this.form,
                company: data.company,
                brand: data.brand,
                link: data.link || '',
                license_code: data.license_code || '',
                license: toArr(data.license),
                qualification: toArr(data.qualification),
                contacter: data.contacter || '',
                contacter_phone: data.contacter_phone || '',
                contacter_email: data.contacter_email || '',
                register_address: toArr(data.register_address),

                origin: (data.origin || '') * 1,
                adslot_type: toArr(data.adslot_type),
                adslot_type_other: !!data.adslot_type_ext,
                operator: (data.operator || '') * 1,
                remarks: data.remarks || ''
            };

            // 下次更新； adslot_type_other 会影响 adslot_type_ext 更新；
            this.$nextTick(() => {
                this.form.adslot_type_ext = data.adslot_type_ext || '';
                setTimeout(() => {
                    this.$refs.form_link.focus();
                    // 后置 部分 array 类校验 trigger 为 ‘change’, 防止提前校验
                    this.rules.category[0].trigger = 'change';
                    this.rules.register_address[0].trigger = 'change';
                    this.rules.adslot_type[0].trigger = 'change';
                });
            });
        },

        // 监听图片删除
        handleDelete (res = {}) {
            const { imgs, sign } = res;
            this.form[sign] = [...imgs];
        },

        // 监听图片上传
        handleUpload (res) {
            const { imgs, sign } = res;
            this.form[sign] = [...imgs];
        },

        // 获取代理数据
        async _fetchAgentList (keyword = '') {
            if (!keyword) {
                this.agentsOps = [];
                return false;
            }

            try {
                const res = await req.send(req.Apis.sales.agent.list, { keyword });
                this.agentsOps = [...res.data] || [];
            } catch (err) {
                this.$message.error(`获取代理失败：${err.message || '未知错误'}`);
            }
        },

        // 选择代理商
        handleSelectAgent (agentId) {
            let selectedItem = (this.agentsOps || []).find(i => i.agent_id === agentId) || {};
            this.$nextTick(() => {
                this.form.agent_name = selectedItem.agent_name || '';
                this.form.channel_sales_id = selectedItem.channel_sales_id || '';
                this.form.channel_sales_name = selectedItem.channel_sales_name || '';
            });
        },

        // 提交表单
        submitFormAction (form) {
            this.$refs[form].validate(valid => {
                if (valid) {
                    this.processSubmit();
                } else {
                    return false;
                }
            });
        },

        // 回退
        backAction () {
            this.$router.go(-1);
        },

        // 查看资质说明
        toViewOpenState () {
            $util.openUrl('/help/qualification', { newWin: true });
        },

        /* mock */
        mockForm () {
            if (isProduction) return;
            const Random = Mock.Random;
            const chats = 'abcABC0123456789';
            const pw = 'aA1' + Random.string(chats, 6, 20);
            this.form = {
                ...this.form,
                account_name: Random.ctitle(5, 10),
                password: pw,
                confirmPassword: pw,
                category: ['100100100', '100101100', '100101101'],
                license_code: Random.string('ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789', 18),
                license: [Random.image('200x100')],
                qualification: [Random.image('200x200')],
                contacter: Random.cname(),
                contacter_phone: Random.integer(17700000000, 18800000000) + '',
                contacter_email: Random.email(),
                register_address: ['山西省', '长治市'],
                link: Random.url('https'),
                origin: Random.pick(aderSource).id,
                adslot_type: [Random.pick(adPosition).id],
                operator: Random.pick(operationSource).id,
                remarks: Random.cparagraph(20, 50)
            };
        }
    },
    created () {
        this.form.customer_id = this.$route.query.id || '';
        this.owner = this.$route.query.owner || '';
        this.formType = this.$route.query.formType || '';
        // 从详情页点击过来时带的一些信息
        if (this.formType === 'edit') {
            this.editFormAdvInfo = JSON.parse(this.$route.query.advInfo) || {};
            this.form.product_id = this.editFormAdvInfo.product_id || '';
        } else if (this.formType === 'init') {
            this.initFormProductInfo = JSON.parse(this.$route.query.productInfo) || {};
            this.form.product_id = this.initFormProductInfo.product_id || '';
        }
        this.rules = {
            ...this.formRules
        };
        this._getCategoryConfig();
        this._getDetail();
    }
};
</script>

<style lang="less" scoped>
/deep/ .el-tag--success {
    height: 24px;
    line-height: 22px;
    color: #61c130;
    background: rgba(240, 248, 235, 1);
    border-radius: 4px;
    border: 1px solid #61c130;
}
/deep/ .el-textarea__inner {
    height: 80px;
}

.pure-text {
    font-weight: bold;
    color: #303133;
}

.form-box {
    width: 680px;

    .form-title {
        padding: 20px 0 24px 0;
    }

    .form-tip-icon {
        position: absolute;
        top: 11px;
        right: -32px;
        z-index: 2;
        width: 16px;
    }
}

.audit-error-tips {
    position: relative;
    padding: 6px 16px;

    p {
        margin: 0;
    }

    .title {
        font-size: 14px;
        font-weight: bold;
        color: rgba(255, 97, 97, 1);
        line-height: 14px;
    }

    .desc {
        padding-top: 10px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(255, 97, 97, 1);
        line-height: 18px;
    }

    img {
        position: absolute;
        top: 4px;
        left: -11px;
        width: 18px;
    }
}
</style>
